// extracted by mini-css-extract-plugin
export var deleteIcon = "_qg-5";
export var deleteOption = "_qg-3";
export var divider = "_qg-2";
export var downloadIcon = "_qg-4";
export var drawer = "_qg-0";
export var drawerFooter = "_qg-6";
export var drawerOpen = "_qg-1";
export var highlighted = "_qg-7";
export var lighterHighlight = "_qg-8";